<template>
  <div class="story-card-container">
    <div class="story-card-wrapper" :class="{'is-marginless' : isMarginless}">
      <router-link :to="isMobileView(path)" :event="'click'">
        <div class="story-card"
             :class="{'story-card story-card-expo-booth story-card-expo-booth_large': size,
             'story-card story-card-expo-booth story-card-expo-booth_regular': this.isStemExpo || $isIsef,
             'story-card story-card-expo-booth story-card-expo-booth_regular_isef': $isIsef && this.isViewAll}"
             @click="emitClick"
             aria-label="Click to view project">
          <div :class="(this.isStemExpo || $isIsef) ? size ? 'info info_stem-expo-booth info_stem-expo-booth_large' :
          'info info_stem-expo-booth': 'info'">
            <template v-if="!isBlank && !isRowLoading">
              <div class="top-line" :class="{'top-line-ajas' : $isAjas || $isYSC}">
                <span v-if="$isAjas || $isYSC"
                      class="author author-ajas "
                      :class="{'info_stem-expo-booth_author info_stem-expo-booth_author_large': size,
                      'info_stem-expo-booth_author': this.isStemExpo,
                      'info_stem-expo-booth_author info_stem-expo-booth_author-viewAll': this.isViewAll,
                      'is-hidden-touch': $isAjas,
                      'bold': $isYSC}">
                  {{ajasAuthors}}
                </span>
              </div>
              <div class="bookmark"
                   :class="{'bookmark_stem-expo-booth_large': size,
                    'bookmark_stem-expo-booth': this.isStemExpo || this.$isIsef,
                    'bookmark_stem-expo-booth_viewAll': this.isViewAll,
                    'fa fa-lock':canView}"
                     >
                <span v-if="!canView" class="icon" :data-balloon="showBalloon('Bookmark', hasSubscribed)" data-balloon-pos="down-right" @click.prevent="canSubscribe">
                  <i class="fa-bookmark step-4-makehome-obm" :class="{fa: hasSubscribed, fal: !hasSubscribed}" aria-label="Click to bookmark project" tabindex="0" @keypress.enter.space="canSubscribe"></i>
                </span>
              </div>
              <visibility-flags v-if="!this.isStemExpo" :project="project" :across="true" />
            </template>
          </div>
          <span>
            <awards :projectAwards="project.awards" :isStemExpo="isStemExpo" :isCareerHall="isCareerHall" :isViewAll="isViewAll"/>
          </span>
          <div class="image-story-container" :class="{'story-card-expo-booth_img_isef': this.$isIsef,
          'story-card-expo-booth_img_large': size,
          'story-card-expo-booth_img': this.isStemExpo,
          'story-card-expo-booth_img_viewAll': this.isViewAll}">
            <div
                 class="image story"
                 :class="{loading: image.loading || (isBlank && isVisible) || isRowLoading,
                 loaded: !isRowLoading && image.loaded || image.error,
                 'image_stem-expo-booth': this.isStemExpo || $isIsef,
                 'image_stem-expo-booth-isef': $isIsef && !this.isViewAll,
                 'image_stem-expo-booth-viewAll': this.isViewAll}"
                 :style="imageBackground"
            />
          </div>
          <div
               class="story-card-expo-booth_title"
               :class="{'story-card-expo-booth_title_large': size,
               'story-card-expo-booth_title_viewAll': this.isViewAll}">
            <div :id="elementID"
                 ref="storyTitle"
                 class="story-title">
              {{ formatTitle(title) }}
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>

import BaseCard from './BaseCard'
import base from '../mixins/base'
import visibility from '@/mixins/visibility'
import subscribe from '@/mixins/subscribe'
import pinnedProject from '@/mixins/pinned-project'
import Awards from '../UI/Awards'
export default {
  components: {
    BaseCard,
    Awards
  },
  props: {
    projectID: Number,
    categoryID: Number,
    storyType: Boolean,
    isMarginless: [Boolean, String],
    isRowLoading: Boolean,
    isPinnableRow: Boolean,
    pinnedProjects: Array,
    size: String,
    disableLink: Boolean
  },
  mixins: [base, visibility, subscribe, pinnedProject],
  computed: {
    isViewAll: function () {
      return this.$route.path.includes('viewAll') && this.$isIsef
    },
    isStemExpo: function () {
      return this.$route.name === 'stem-expo' || this.$route.path.includes('stem-expo')
    },
    isCareerHall: function () {
      return this.$route.name === 'career-hall' || this.$route.path.includes('career-hall')
    },
    isMobile: function () {
      return (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
    }
  },
  methods: {
    isMobileView: function (path) {
      if (this.isMobile && this.$isIsef) {
        return path.replace('finalist-booth', 'project')
      } else {
        return path
      }
    },
    formatTitle: function (title) {
      if (title && title.length > 70) {
        return title.substring(0, 70) + '...'
      } else {
        return title
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .bold {
    font-weight: bold;
  }

  .award {
    position: absolute;
    top: 120px;
    width: 36px;
    height: 45px;

    @include tablet-only {
      top: 100px
    }
    @include mobile {
      top: 95px;
    }
  }

  .award_stemexpo {
    position: absolute;
    height: 45px;
    width: 36px;
    bottom: 40px !important;
    @include tablet-only {
      top: 40px
    }
    @include mobile {
      top: 45px;
    }
  }

  .award_isef {
    position: absolute;
    bottom: 34px;
    width: 36px;
    height: 45px;

    &_careerHall {
      width: 49px !important;
      height: 55px !important;
    }

    &_viewAll {
      bottom: 22px !important;
      @include tablet {
        top: inherit !important;
      }
      @include mobile {
        top: inherit !important;
      }
    }
  }

  .user {
    align-items: center;
    .username {
      font-size: 0.7rem;
      font-weight: 400;
    }
  }

  #storyTitle {
    background: grey;
  }

  a {
    color: $grey-darker;
  }

  .story-card-wrapper {
    &:not(.is-marginless) {
      margin: 1rem;
      margin-left: 0;
    }
  }

  .story-card {
    height: 270px;
    width: 260px;
    background-color: var(--background-story-card);
    position: relative;
    font-family: "Roboto";

    -webkit-box-shadow: 0px 2px 5px 0px rgba(168,168,168,.5);
    -moz-box-shadow: 0px 2px 5px 0px rgba(168,168,168,.5);
    box-shadow: 0px 2px 5px 0px rgba(168,168,168,.5);

    &-expo-booth {
      background-image: url('https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/IsefResources%2Fstem_expo_booth_v1.png?alt=media&token=91a455e5-9f9c-4851-a1b7-f8f072d17a19');
      background-size: cover !important;
      background-position: center !important;
      background-color: transparent !important;
      box-shadow: none !important;

      &:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: transparent !important;
        opacity: 0;
        transition: all 0.35s;
      }
      &:hover:after {
        opacity: 1;
      }
      &:hover {
        transform: scale(1.015);
        box-shadow: 0px 5px 15px -1px #62626270;
      }
      i {
        z-index: 1;
      }

      &_regular {
        height: 370px !important;
        width: 360px !important;
      }
      // View all for isef
      &_regular_isef {
        height: 300px !important;
        width: 290px !important;
      }

      &_large {
        height: 420px !important;
        width: 430px !important;
      }

      &_title {
        padding: 0.5rem 4.2rem;
        &_viewAll {
          @include tablet {
            padding: 0.2rem 3.3rem !important;
            font-size: 0.75em !important;
          }
          @include mobile {
            padding: 0.2rem 4rem !important;
            font-size: 0.75em !important;
          }
        }
        &_large {
          padding: 1rem 5rem !important;
        }
      }

      &_img {
        padding: 0 3.7rem;
        margin-left: -5px;
        background-color: transparent;

        &_viewAll {
          padding: 0 2.9rem !important;
          margin-top: -7px !important;
        }

        &_isef {
          padding: 0.4rem 3.6rem;
          margin-left: -4px;
        }

        &_large {
          margin-left: -6px;
          padding: 0 4.7rem;
          margin-top: -18px;
        }

        @include mobile {
          margin-left: -3px;
          width: auto;
        }
      }
    }

    @include tablet-only {
      width: 220px;
      height: 221px;
    }
    @include mobile {
      width: 164px;
      height: 201px;
    }

    @include hover-cards-effect;

    .info {
      padding: 1.3rem;
      height: 140px;
      position: relative;
      &_stem-expo-booth {
        padding: .83rem !important;
        height: auto !important;
        &_large {
          height: 95px !important;
        }
        &_author {
          position: absolute;
          max-width: 250px;
          margin-top: 1.4rem !important;
          padding-left: 2.3rem !important;
          // View all
          &-viewAll {
            margin-top: .8rem !important;
          }
          &_large {
            padding-left: 4rem !important;
            font-size: 1.3em;
          }
        }
      }
      @include tablet-only {
        height: 120px;
        padding: 1rem 0.9rem;
      }
      @include mobile {
        height: 112px;
        padding: 0.84rem 0.76rem 0.64rem 0.76rem;
      }
      .top-line {
        white-space: nowrap;
        font-size: 0.75rem;
        height: 1rem;
        overflow: hidden;
        margin-bottom: 1rem;
        width: 179px;
        text-overflow: ellipsis;
        letter-spacing: 0;
        @include touch {
          margin-bottom: 0.63rem;
        }
        @include mobile {
          width: 128px;
        }
        .category {
          color: $secondary;
          font-weight: 500;
          margin-right: 0.25rem;
        }
        .category-projects {
          @include touch {
            font-size: .6rem;
          }
        }
        .author {
          color: #aaaaaa;
        }
        .container {
          position: absolute;
          left: 0;
          align-items: center;
        }
      }
      .top-line-ajas {
        height: 2.1rem;
        overflow-wrap: break-word;
        margin-bottom: 0.25rem;
      }
      .bookmark {
        position: absolute;
        right: 0.50rem;
        top: 0.60rem;
        color: $primary;
        padding: 0.5rem;

        &_stem-expo-booth {
          right: 3rem !important;
          top: 0.8rem !important;
          color: #00ADEE !important;

          &_viewAll {
            @include tablet {
              right: 2.5rem !important;
              top: 0.48rem !important;
            }
          }

          &_large {
            right: 4rem !important;
          }
        }

        .icon {
          width: 1.20rem;
        }
        @include touch {
          top: 0.2rem;
          right: 0.4rem;
          font-size: 0.88rem;
        }
        @include mobile {
          right: 0;
          .icon {
            width: 1rem;
          }
        }
        @include tablet-only {
          right: 0;
        }
      }
      .story-title {
        margin: 0 0 1em 0;
        overflow: hidden;
        word-break: break-word !important;
        color: $black;
        font-weight: 600;
        font-size: 1em;
        line-height: 1.45;
        color: var(--background-third);
        @include touch {
          font-size: 0.95rem;
          line-height: 1.35;
        }
      }
      .project-title {
        min-height: 2.6rem;
        font-size: 0.95rem;
        @include touch {
          font-size: 0.85rem;
          margin: 0 0 .65em 0;
          min-height: 2rem;
        }
      }
    }
    .info-projects {
      padding: .9rem;
      @include touch {
        padding: .7rem;
      }
    }
    .image {
      height: 130px;
      width: 100%;
      background-size: cover;
      background-position: center;
      overflow: hidden;

      &_stem-expo-booth {
        height: 129px !important;
        &-viewAll {
          height: 100px !important;
        }
        @include tablet-only {
          height: 130px !important;
        }
        @include mobile {
          height: 130px !important;
        }
      }

      @include tablet-only {
        height: 100px;
      }
      @include mobile {
        height: 89px;
      }

      &.loading {
        animation: loading 1s linear infinite;
        background-image: linear-gradient(to right, #F8F8F8 0%, white 20%, #F8F8F8 40%, #F8F8F8 100%);
        background-size: 250% 250%;

        @keyframes loading {
          0% { background-position: -100% 0; }
          100% { background-position: 100% 0; }
        }
      }

      &.loaded {
        background-size: cover;
        background-position: center;
      }
    }
    .author-ajas {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .eng-com-container {
      width: 100%;
      .author-eng {
        margin-left: 0.4rem;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: 8rem;
        z-index: 5;
      }
    }
  }
</style>
